export default __webpack_public_path__ + "static/media/26.c924af76.png";